export default "__VITE_ASSET__04BNt5kZ__"